<template>
    <div class="card-form" ref="getHeight" >
      <el-scrollbar style="height: 100%;" ref="elScrll" :class="[tableStyleField.isInitTable === false && !isGetListData ? 'init-scroll' : '', tableData.length === 0 ? 'full-height' : '']">
        <div class="card-container">
          <template v-if="tableData.length !== 0">
            <div :class="isFixedSpacing ? 'fix-spacing' : ''" class="card-container-item" @click="$emit('list-click', item)" :style="{ width: sizeWidth, height: `${cardConfig.height}px`, margin: `${minSapcing / 2}px ${spacing}px` }" v-for="(item, index) in tableData" :key="item.approvingId">
              <el-card 
                :shadow="isShadow ? 'always' : 'never'" 
                style="border: none; overflow: auto;">
                <CardForm 
                  :data="item" 
                  :listTodoConfig="listTodoConfig"
                  :cardConfig="cardInfo" 
                  :customDeskId="customDeskId"
                  :screenRef="screenRef"
                  @openAppInitiate="val => { $emit('openAppInitiate', val) }"
                  @edit-user-info="(val, row) => { $emit('edit-user-info', val, row) }"
                  @appPrint="(val) => { $emit('appPrint', val) }"
                  @edit-btn="$emit('edit-btn', item)" 
                  @del-btn="$emit('del-btn', index)" 
                  @open-appDialog="val => { $emit('open-appDialog', val) }"
                  @custom-scene="val => { $emit('custom-scene', val) }"
                  @todo-inside="$emit('todo-inside', $event)"
                  @tableDetail="(data, dataInfo, type)=>{ $emit('tableDetail', data, dataInfo, type) }"
                />
              </el-card>
            </div>
          </template>
          <template v-else>
              <template v-if="tableStyleField.isInitTable === false">
                <initPage :config="initConfig" />
              </template>
              <template v-else>
                <div class="no-data">暂无数据</div>
              </template>
          </template>
        </div>
      </el-scrollbar>
      <div class="reload" @click="goReload" v-if="isConfig" title="刷新数据">
        <i class="iconfont icon-shuaxin"></i>
      </div>
    </div>
</template>
  
<script>
import CardForm from './cardForm.vue'
import initPage from "@/components/schoolInstrument/component/mutual/component/form/initPage.vue";
import { isScrollAtBottom } from '@/components/schoolInstrument/mixins/utils'
import { getUserMoreInfo } from "@/components/common/card/js/util.card.js";
import { cloneDeep } from 'lodash';
export default {
  name: 'cardCpn',
  data() {
      return {
          // 下面两字字段辅助分辨率变化的数据
          widthValue: '',
          tableData: []
      };
  },
  props: {
      // 卡片模式的配置信息
      cardConfig: {
          type: Object,
          default: () => {
            return {
                shape: 'square',
                height: '265px',
                adaption: 'yes',
                count: 4
            };
          }
      },
      // 列表的信息
      listInfo: {
          type: Object,
          default: () => {
              return {};
          }
      },
      cardInfo: {
          type: Object,
          default: () => ({})
      },
      isConfig: {
        type: Boolean,
        default: false
      },
      minSapcing: {
        type: Number,
        default: 10
      },
      listTodoConfig:{
        type: Array,
        default: ()=>([])
      },
      tableStyleField:{
        type: Object,
        default: ()=>({})
      },
      initConfig:{
        type: Object,
        default: ()=>({})
      },
      defaultPrecent:{
        type: Number,
        default: 50
      },
      isGetListData:{
        type: Boolean,
        default: false
      },
      customDeskId: {
        type: [String, Number],
        default: 0
      },
      screenRef: {
        type: Array,
        default: ()=>([])
      },
      
  },
  updated(){
    this.getWdithValue()
    this.watchScrollToBootom()
  },
  mounted() {
    setTimeout(() => {
      this.watchScrollToBootom()
      this.getWdithValue()
    }, 100);
    window.addEventListener('resize', this.getWdithValue)
  },
  watch: {
    defaultPrecent: {
      handler() {
        setTimeout(() => {
          this.$nextTick(this.getWdithValue)
        }, 500);
      }
    },
    'listInfo.tableData': {
      async handler (val) {
        if (Array.isArray(val)) {
          const canvasChildren = this.cardInfo.configList[this.cardInfo.activeConfig].children || []
          this.tableData = await getUserMoreInfo(cloneDeep(val), canvasChildren)
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    isFixedSpacing() {
      return this.cardConfig.adaptionFn === 'fixedSpacing'
    },
    spacing () {
      const width = this.widthValue
      const isAdaption = this.cardConfig.adaption === 'yes'
      if (!isAdaption || this.cardConfig.adaptionFn === 'fixedSpacing') {
        return this.minSapcing / 2
      }
      if (!width) return 0
      const adaption = this.cardConfig.count
      const COMMON = 0
      if (!this.cardInfo && !this.cardInfo.configList) {
          return COMMON
      }
      const tw = parseInt(width) - this.minSapcing
      const pw = parseInt(this.sizeWidth) * adaption
      const mr = tw - pw
      const res = mr / adaption / 2
      return res
    },
    sizeWidth () {
      if (this.cardConfig && this.cardConfig.adaptionFn === 'fixedSpacing') {
        return `calc(${100 / this.cardConfig.count}% - ${this.minSapcing / 2}px)`
      }
      if (this.cardInfo && this.cardInfo.configList && this.cardInfo.configList[0]) {
        return this.cardInfo.configList[0].canvasWidth + 'px'
      } else {
        return ''
      }
    },
    isShadow () {
      return this.cardInfo.configList[this.cardInfo.activeConfig].shadow
    }
  },
  methods: {
    delTableData (index) {
      if (index >= 0) {
        this.tableData.splice(index, 1)
      }
    },
    goReload () {
      this.$emit('goReload')
      this.$message.success('刷新成功')
    },
      getWdithValue() {
          this.$nextTick(() => {
            if (this.$refs.getHeight) {
              this.widthValue = this.$refs.getHeight.offsetWidth
            }
          })
      },
      watchScrollToBootom() {
        if (this.tableStyleField.loadingMethod !== 'scroll') return
        setTimeout(() => {
          if (!this.$refs.elScrll) return
          const scrollbarEl = this.$refs.elScrll.wrapRef
          scrollbarEl.onscroll = (el) => {
            if (isScrollAtBottom(el)) {
              this.$emit('toBottom')
            }
          }
          }, 500)
      },
  },
  components: { CardForm, initPage }
}
</script>
<style lang='scss' scoped>
:deep(.fix-spacing) {
  .card-form-box {
    width: 100% !important;
  }
}
.card-form {
  height: 100%;
    .card-container {
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        align-content: start;
        position: relative;
        &-item {
            box-sizing: border-box;
            // overflow: hidden;
            :deep(.el-card) {
                width: 100%;
                height: 100%;
                .el-card__body {
                    height: 100%;
                }
            }
        }
        .no-data {
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 10px 0;
            width: 100%;
            height: 100%;
        }
    }
}
:deep(.card-container .el-card) {
  background-color: transparent;
}
:deep(.init-scroll), :deep(.full-height) {
  .el-scrollbar__view {
    height: 100%;
    .card-container {
      height: 100%;
      .no-data {
        color: #909399;
      }
    }
  }
}

:deep(.el-card__body) {
    padding: 0;
}
.reload {
  position: absolute;
  bottom: 20px;
  right: 20px;
  width: 40px;
  height: 40px;
  cursor: pointer;
  background: #FFFFFF;
  box-shadow: -1px 3px 12px 1px rgba(15,5,10,0.08);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  .iconshuaxin1{
    font-size: 28px;
  }
}
</style>